import {Subscription} from "rxjs";
import {RouterLink} from "@angular/router";
import {Component, HostListener, inject, OnDestroy, OnInit} from '@angular/core';

import {appRoutes} from "@numizmat/constants";
import {NgbCollapse} from "@ng-bootstrap/ng-bootstrap";
import {CurrentUserStateService} from "@numizmat/services/account";

import {LogoComponent} from "../logo/logo.component";

@Component({
    selector: 'nz-navbar',
    imports: [
        RouterLink,
        NgbCollapse,
        LogoComponent
    ],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit, OnDestroy {
  private currentUserStateService: CurrentUserStateService = inject(CurrentUserStateService);

  protected readonly appRoutes = appRoutes;
  private currentUserStateSubscription: Subscription | undefined;

  public userId?: string;
  public loggedIn: boolean = false;

  protected newMessageCount: number = 0;
  protected newNotificationCount: number = 0;

  public isCollapsed: boolean = true;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;

    if (!targetElement.closest('.navbar-collapse') && !targetElement.closest('.navbar-toggler')) {
      this.isCollapsed = true;
    }
  }

  public ngOnInit(): void {
    this.currentUserStateSubscription = this.currentUserStateService.getCurrentUser().subscribe({
      next: currentUser => {
        if (currentUser.loggedIn && !!currentUser.userData) {
          this.loggedIn = true;
          this.userId = currentUser.userData.userId;
          this.newMessageCount = currentUser.userData.newMessageCount;
          this.newNotificationCount = currentUser.userData.newNotificationCount;
        } else {
          this.loggedIn = false;
          this.newMessageCount = 0;
          this.newNotificationCount = 0;
        }
      }
    });
  }

  public ngOnDestroy(): void {
    this.currentUserStateSubscription?.unsubscribe();
  }
}
